import { API_URL } from 'constants/api';
import { getCookie } from './lib';
const { serialize } = require('object-to-formdata');

const _get = endpoint => {
  const req = fetch(`${API_URL}${endpoint}`, {
    headers: { 'Content-Type': 'application/json', 'Cross-Origin-Resource-Policy': 'cross-origin' },
    method: 'GET',
  });

  return req
    .then(res => {
      if (!res.ok) {
        return res.text().then(text => {
          throw new Error(`${res.status}: ${text}`);
        });
      }

      return res;
    })
    .then(res => res.json())
    .catch(e => {
      throw new Error(e);
    });
};

export const getYoutubeVideosData = () =>
  _get('youtube/videos/UCZkM0Uukj00gyTqjVO18HWw').then(res => res.data[0].videos);
export const getYoutubeShortsData = () => _get('youtube/shorts').then(res => res.data[0].videos);
export const getPodcastsRubrics = () => _get('radio/rubrics');
export const getPodcastsByRubricId = id => _get(`radio/${id}`);
export const getLatestPodcasts = () => _get('radio/latest');
export const getTop8Podcasts = () => _get('radio/top');

const _postFormData = (url, data) => {
  const withUtm = { ...data, gclid: getCookie('gclid') };

  const body = serialize(withUtm, { indices: true, nullsAsUndefineds: true });

  const req = fetch(url, {
    method: 'POST',
    headers: { 'Cross-Origin-Resource-Policy': 'cross-origin' },
    body,
  });

  return req.then(res => {
    if (!res.ok) {
      return res.text().then(text => {
        throw new Error(`${res.status}: ${text}`);
      });
    }

    return res;
  });
};

export const sendFormData = data => _postFormData(`${API_URL}mail/send`, data);
